/** Where competitor accounts can be added by handle (TikTok and Instagram parse links too). */
export const HANDLE_PLATFORMS = ['TIKTOK', 'INSTAGRAM'] as const;
export type HandlePlatform = (typeof HANDLE_PLATFORMS)[number];

/** Where a persona's own accounts can be added by handle or profile link. */
export const PERSONA_PLATFORMS = ['TIKTOK', 'INSTAGRAM', 'YOUTUBE', 'FACEBOOK'] as const;
export type PersonaPlatform = (typeof PERSONA_PLATFORMS)[number];

export const HANDLE_PLATFORM_LABEL: Record<PersonaPlatform, string> = {
  TIKTOK: 'TikTok',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  FACEBOOK: 'Facebook',
};

const LINK_HOSTS: Record<PersonaPlatform, RegExp> = {
  TIKTOK: /^(https?:\/\/)?([\w-]+\.)*tiktok\.com\//,
  INSTAGRAM: /^(https?:\/\/)?([\w-]+\.)*instagram\.com\//,
  YOUTUBE: /^(https?:\/\/)?([\w-]+\.)*(youtube\.com|youtu\.be)\//,
  FACEBOOK: /^(https?:\/\/)?([\w-]+\.)*(facebook\.com|fb\.com)\//,
};

/** The platform a pasted profile link is on, or null for a plain handle. */
export function linkPlatform(input: string): HandlePlatform | null;
export function linkPlatform<P extends PersonaPlatform>(
  input: string,
  platforms: readonly P[],
): P | null;
export function linkPlatform(
  input: string,
  platforms: readonly PersonaPlatform[] = HANDLE_PLATFORMS,
): PersonaPlatform | null {
  const value = input.trim().toLowerCase();
  return platforms.find((platform) => LINK_HOSTS[platform].test(value)) ?? null;
}
